import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/common/ui/typographyStyle';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  text: React.ReactNode;
  author?: React.ReactNode;
  textClassName?: string;
  authorClassName?: string;
};

const Quote: React.FC<ComponentProps> = (props) => {
  const {
    text,
    author,
    authorClassName = 'default-author',
    textClassName = 'defalut-text'
  } = props;
  const classes = useStyles();
  const quoteClasses = classNames(classes.defaultFontStyle, classes.quote);
  const quoteTextClasses = classNames({
    [classes.quoteText]: true,
    [textClassName]: textClassName !== undefined
  });
  const quoteAuthorClasses = classNames({
    [classes.quoteAuthor]: true,
    [authorClassName]: authorClassName !== undefined
  });
  return (
    <blockquote className={quoteClasses}>
      <p className={quoteTextClasses}>{text}</p>
      <small className={quoteAuthorClasses}>{author}</small>
    </blockquote>
  );
};

export default Quote;
